export enum DeviceAuthorizationStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  DENIED = 'denied',
  REVOKED = 'revoked',
}

export enum DeviceType {
  MOBILE = 'mobile',
  WEB = 'web',
}

export enum EvaluationSessionStatus {
  INITIATED = 'initiated',
  COMPLETED = 'completed',
  ARCHIVED = 'archived',
}

export enum FeedbackStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
}

export enum FeedbackType {
  BUG = 'BUG',
  FEATURE = 'FEATURE',
  CONTACT = 'CONTACT',
  OTHER = 'OTHER',
}

export enum Gender {
  MAN = 'MAN',
  WOMAN = 'WOMAN',
  OTHER = 'OTHER',
}

export enum Language {
  FR = 'FR',
  EN = 'EN',
}

export enum NotificationType {
  SYSTEM = 'SYSTEM',
  SUBSCRIPTION = 'SUBSCRIPTION',
  INSTITUTION_INVITE = 'INSTITUTION_INVITE',
  INSTITUTION_INVITE_ACCEPTED = 'INSTITUTION_INVITE_ACCEPTED',
  INSTITUTION_INVITE_DECLINED = 'INSTITUTION_INVITE_DECLINED',
  // Deprecated: kept for DB backward compatibility with existing notification records
  INSTITUTION_LICENSE_REMOVED = 'INSTITUTION_LICENSE_REMOVED',
  INSTITUTION_LICENSE_PURCHASED = 'INSTITUTION_LICENSE_PURCHASED',
  INSTITUTION_LICENSE_EXPIRING = 'INSTITUTION_LICENSE_EXPIRING',
  INSTITUTION_LICENSE_EXPIRED = 'INSTITUTION_LICENSE_EXPIRED',
  DEVICE_AUTHORIZATION_REQUESTED = 'DEVICE_AUTHORIZATION_REQUESTED',
  DEVICE_AUTHORIZATION_APPROVED = 'DEVICE_AUTHORIZATION_APPROVED',
  DEVICE_AUTHORIZATION_DENIED = 'DEVICE_AUTHORIZATION_DENIED',
}

export enum Platform {
  WEB = 'WEB',
  IOS = 'IOS',
  ANDROID = 'ANDROID',
}

export enum Theme {
  SYSTEM = 'SYSTEM',
  LIGHT = 'LIGHT',
  DARK = 'DARK',
}

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export enum UserType {
  INSTITUTION = 'INSTITUTION',
  PRACTITIONER = 'PRACTITIONER',
  ADMIN = 'ADMIN',
}

export enum RecommendationSeverity {
  INFO = 'info',
  NOTICE = 'notice',
  WARNING = 'warning',
  CRITICAL = 'critical',
}

export enum UserSource {
  MOBILE = 'MOBILE',
  GOOGLE = 'GOOGLE',
  FACEBOOK = 'FACEBOOK',
  LINKEDIN = 'LINKEDIN',
  EMAIL = 'EMAIL',
  ADS = 'ADS',
  OTHER = 'OTHER',
  RECOMMENDATION = 'RECOMMENDATION',
}

export enum TrainingType {
  PRACTITIONER = 'PRACTITIONER',
  INSTITUTION = 'INSTITUTION',
}
